import { create } from 'zustand'
import {
  CCConfigType,
  DatatransType,
  InitialCCConfig,
  InitialPaymentConfig,
  PaymentConfigType,
  SaferPayType
} from './types'
import { GET } from 'shared/api/GET'
import { POST } from 'shared/api/POST'
import { useLoadingStore } from './toasterSlice'
import { consoleError } from 'shared/helpers/consoleError'
import { useBranchStore } from './branchesSlice'

const getInitialConfigStore = () => ({
  isConfigDataLoading: false,
  isConfigLoaded: false,
  paymentConfig: InitialPaymentConfig,
  clickCollectConfig: InitialCCConfig
})

export const usePaymentConfigStore = create<IPaymnetConfigStore>((set, get) => ({
  ...getInitialConfigStore(),
  loadPaymentConfig: async () => {
    set(state => {
      return {
        ...state,
        isConfigDataLoading: true
      }
    })

    try {
      const branchId = useBranchStore.getState().branchId
      const config = await GET.config(branchId || 0)
      set(state => {
        const paymentConfig = config?.paymentConfig || InitialPaymentConfig
        const clickCollectConfig = config?.clickCollectConfig || InitialCCConfig
        return {
          ...state,
          paymentConfig,
          clickCollectConfig,
          isConfigLoaded: Boolean(config?.paymentConfig)
        }
      })
    } catch (error) {
      consoleError(error)
    } finally {
      set(state => {
        return {
          ...state,
          isConfigDataLoading: false
        }
      })
    }
  },
  updatePaymentProvider: async (value: 0 | 1 | 2 | 3) => {
    const { startLoading, finishWithSuccess, finishWithError } = useLoadingStore.getState()
    set(state => {
      return {
        ...state,
        isConfigDataLoading: true
      }
    })
    startLoading()
    try {
      let result
      if (value === 0) {
        result = await POST.updatePaymentOnSite(true)
      } else {
        result = await POST.updatePaymentProvider(value)
      }
      const paymentConfig = result?.paymentConfig || InitialPaymentConfig
      set(state => {
        return {
          ...state,
          paymentConfig
        }
      })
      finishWithSuccess()
    } catch (error: any) {
      consoleError(error)
      finishWithError()
    } finally {
      set(state => {
        return {
          ...state,
          isConfigDataLoading: false
        }
      })
    }
  },
  updateCCConfig: async (payload: Partial<CCConfigType>) => {
    const { startLoading, finishWithSuccess, finishWithError } = useLoadingStore.getState()
    set(state => {
      return {
        ...state,
        isConfigDataLoading: true
      }
    })
    startLoading()
    try {
      const result = await POST.updateCCInterface(payload)
      const clickCollectConfig = result?.clickCollectConfig || InitialCCConfig
      set(state => {
        return {
          ...state,
          clickCollectConfig
        }
      })
      finishWithSuccess()
    } catch (error: any) {
      consoleError(error)
      finishWithError()
    } finally {
      set(state => {
        return {
          ...state,
          isConfigDataLoading: false
        }
      })
    }
  },
  updateDataTransConfig: async (payload: Partial<DatatransType>) => {
    const { startLoading, finishWithSuccess, finishWithError } = useLoadingStore.getState()
    set(state => {
      return {
        ...state,
        isConfigDataLoading: true
      }
    })
    startLoading()
    try {
      const datatransConfig = get().paymentConfig.dataTrans
      const result = await POST.updateDatatrans({ ...datatransConfig, ...payload })
      const paymentConfig = result?.paymentConfig || InitialPaymentConfig
      set(state => {
        return {
          ...state,
          paymentConfig
        }
      })
      finishWithSuccess()
    } catch (error: any) {
      consoleError(error)
      finishWithError()
    } finally {
      set(state => {
        return {
          ...state,
          isConfigDataLoading: false
        }
      })
    }
  },
  updateSaferPayConfig: async (payload: Partial<SaferPayType>) => {
    const { startLoading, finishWithSuccess, finishWithError } = useLoadingStore.getState()
    set(state => {
      return {
        ...state,
        isConfigDataLoading: true
      }
    })
    startLoading()
    try {
      const saferPayConfig = get().paymentConfig.saferPay
      const result = await POST.updateSaferPay({ ...saferPayConfig, ...payload })
      const paymentConfig = result?.paymentConfig || InitialPaymentConfig
      set(state => {
        return {
          ...state,
          paymentConfig
        }
      })
      finishWithSuccess()
    } catch (error: any) {
      consoleError(error)
      finishWithError()
    } finally {
      set(state => {
        return {
          ...state,
          isConfigDataLoading: false
        }
      })
    }
  },
  updateHSPayConfig: async (shopId: string) => {
    console.log('🚀 ~ shopId:', shopId)
    const { startLoading, finishWithSuccess, finishWithError } = useLoadingStore.getState()
    set(state => {
      return {
        ...state,
        isConfigDataLoading: true
      }
    })
    startLoading()
    try {
      const result = await POST.updateHSPay(shopId)
      const paymentConfig = result?.paymentConfig || InitialPaymentConfig
      set(state => {
        return {
          ...state,
          paymentConfig
        }
      })
      finishWithSuccess()
    } catch (error: any) {
      consoleError(error)
      finishWithError()
    } finally {
      set(state => {
        return {
          ...state,
          isConfigDataLoading: false
        }
      })
    }
  }
}))

export interface IPaymnetConfigStore {
  isConfigDataLoading: boolean
  isConfigLoaded: boolean
  paymentConfig: PaymentConfigType
  clickCollectConfig: CCConfigType
  loadPaymentConfig: () => void
  updatePaymentProvider: (value: 0 | 1 | 2) => void
  updateCCConfig: (payload: Partial<CCConfigType>) => void
  updateDataTransConfig: (payload: Partial<DatatransType>) => void
  updateSaferPayConfig: (payload: Partial<SaferPayType>) => void
  updateHSPayConfig: (payload: string) => void
}
